<template>
  <div class="page-401">
    <div class="part">
      <img class="img" src="@/assets/img/404.png" alt="oops">
    </div>
    <div class="part">
      <h1 class="text-oops">{{$t('401.oops')}}</h1>
      <h2>{{$t('404.notFound')}}</h2>
      <p class="link-container">
        <a class="text-link" @click="$router.go(-2)" >{{$t('401.goback')}}</a>
        <router-link class="text-link" to="/home">{{$t('401.gohome')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    }
  },
}
</script>

<style lang="less" scoped>
.page-401 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .part {
    &:not(:last-child) {
      margin-right: 30px;
    }
    .img {
      width: 600px;
    }
    .text-oops {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
      margin-bottom: 10px;
    }
    .link-container {
      margin-top: 20px;
      .text-link {
        cursor: pointer;
        color: #008489;
        text-decoration: none;
        margin-right: 20px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
